import { headerState } from 'app/src/components/Header/headerState';

export interface HeaderOptions {
  headerBrandingColor?: string;
  headerBrandingLogo?: string;
  headerBrandingName?: string;
}

export const headerBranding = (opts: HeaderOptions) => {
  if (opts.headerBrandingName) {
    headerState.setValue({
      brandingName: opts.headerBrandingName,
    });
  } else {
    headerState.setValue({
      brandingName: undefined,
    });
  }
};
